import { ActionStatus } from '../../../Constants';

export default function artificialStaffAction(gamePlayerController, aiPackage) {
    aiPackage.success = true;
    switch (gamePlayerController.gamePlayerData.action_status) {
    case ActionStatus.INIT_ID:
        aiPackage.addToMessage(`Clock-In Staff`);
        // gamePlayerController.buyRobot();
        return aiPackage;
    case ActionStatus.WAIT_ID:
        aiPackage.addToMessage(`Clock-In Staff WAIT Unsupported`);
        // gamePlayerController.buyRobot();
        return aiPackage;
    case ActionStatus.DONE_ID:
        aiPackage.addToMessage('Clock-In Staff Done Unsupported'); // this is not used.
        return aiPackage;
    default:
        console.error('Staff Too Far.', gamePlayerController.gamePlayerData.action_status);
        break;
    }
}
